import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, RowFields } from 'components'
import { Cont } from './styled'

const AttachmentComponent = (props) => {

  const { 
    valueForm,
    change,
    // props
    isCreate = false,
    isEdit = false,
    isDetail = false,
  } = props

  const checkEditMode = () =>{
    return isCreate||isEdit
  }

  const fileChange = (key,value) =>{
    change('formBGCompany',key,value)
  }

  const getFileBGC03 = () =>{
    return valueForm.attachments.filter(x=>x.documentCode=='BGC03')
  
  }
  const getFileBGC04 = () =>{
    return valueForm.attachments.filter(x=>x.documentCode=='BGC04')
  }

  return (
    <StdCard title={<span className='stepTitle'>Attachment</span>}>
      <Cont>
        <RowFields style={{justifyContent:'space-around'}}>
          <Field 
            name='bgc03' 
            label='Bank Guarantee'
            type={type.file}
            editable={checkEditMode()}
            multipleSelect={false}
            limitFileItem={1}
            component={FieldInput} 
            oldFiles={getFileBGC03()}
            showOldFile={isEdit||isDetail}
            change={fileChange}
            removeOldFiles={(index, id) => {
              let findIndex = valueForm.attachments.findIndex(x=>x.id==id)
              if(findIndex>=0) fileChange(`attachments[${findIndex}].deleted`,true)
            }}
            acceptFileType='.pdf'
            require />
          <Field 
            name='bgc04' 
            label='Other' 
            type={type.file}
            editable={false}
            component={FieldInput} 
            oldFiles={getFileBGC04()}
            showOldFile={isEdit||isDetail}
            change={fileChange}
            // removeOldFiles={(index, id) => {
            //   let findIndex = valueForm.attachments.findIndex(x=>x.id==id)
            //   if(findIndex>=0) fileChange(`attachments[${findIndex}].deleted`,true)
            // }}
          />
        </RowFields>
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompany')(state) || {attachments:[]},
  }
}

const mapDispatchToProps = {
  change
}

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentComponent)
